export const TUTOR = 'Tutor';
export const STUDENT = 'Student';



// WEBPACK FOOTER //
// ./src/constants/userRole.js